// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__--NMN","questions":"styles_questions__17i7X","footer":"styles_footer__1ETcy"};